import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
    <nav className = "ab">
      <div className="navlinks">
        
      <a className="abc" href="#about">About</a>
      <a className="abc" href="#projects">Projects</a>
      <a className="abc" href="#contact">Contact</a>
       
      </div>
    </nav>
    <p>Copyright &#169; 2024 Mohit Pal. All Rights Reserved.</p>
  </footer>
  
  );
}

export default Footer;
